(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magora-offer-bar"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('magora-offer-clock')){
    customElements.define('magora-offer-clock',class extends HTMLElement{
      connectedCallback(){
        const hours=this.querySelector('[data-clock-hours]');
        const minutes=this.querySelector('[data-clock-minutes]');
        const seconds=this.querySelector('[data-clock-seconds]');
        const update=()=>{
          const now=new Date();
          const midnight=new Date(now);
          midnight.setHours(24,0,0,0);
          const remaining=Math.max(0,Math.ceil((midnight.getTime()-now.getTime())/1000));
          hours.textContent=String(Math.floor(remaining/3600)).padStart(2,'0');
          minutes.textContent=String(Math.floor(remaining%3600/60)).padStart(2,'0');
          seconds.textContent=String(remaining%60).padStart(2,'0');
        };
        clearInterval(this.clockInterval);
        update();
        this.clockInterval=setInterval(update,1000);
      }
      disconnectedCallback(){clearInterval(this.clockInterval);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magora-product-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('magora-product')) {
    customElements.define('magora-product', class extends HTMLElement {
      connectedCallback() {
        if(this.ready) return;
        this.ready=true;
        const images=[...this.querySelectorAll('[data-gallery-image]')];
        const thumbs=[...this.querySelectorAll('[data-gallery-thumb]')];
        const stage=this.querySelector('.mx-stage');
        let current=0;
        const show=(index)=>{
          current=(index+images.length)%images.length;
          images.forEach((image,i)=>image.hidden=i!==current);
          thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===current)));
        };
        thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
        this.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(current-1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(current+1));
        let pointerStart=null;
        stage?.addEventListener('pointerdown',(event)=>{pointerStart={x:event.clientX,y:event.clientY};});
        stage?.addEventListener('pointerup',(event)=>{
          if(!pointerStart) return;
          const dx=event.clientX-pointerStart.x;
          const dy=event.clientY-pointerStart.y;
          pointerStart=null;
          if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)) show(current+(dx<0?1:-1));
        });
        stage?.addEventListener('pointercancel',()=>{pointerStart=null;});
        this.querySelectorAll('[data-country-flag]').forEach(flag=>{
          const code=flag.dataset.countryFlag?.toUpperCase();
          if(/^[A-Z]{2}$/.test(code)) flag.textContent=String.fromCodePoint(...[...code].map(letter=>127397+letter.charCodeAt(0)));
        });
        const form=this.querySelector('.mx-product-form');
        const button=this.querySelector('[data-atc]');
        const quantity=this.querySelector('[data-quantity-input]');
        const sync=(radio)=>{
          quantity.value=radio.dataset.count;
          this.querySelectorAll('[data-current-price]').forEach(el=>el.textContent=radio.dataset.price);
          this.querySelector('[data-sticky-offer]').textContent=radio.dataset.count==='2'?'Buy 1 Get 1 FREE':'1 bracelet only';
          this.querySelector('[data-sticky] s').hidden=radio.dataset.count!=='2';
          button.disabled=radio.dataset.available!=='true';
          this.querySelector('[data-atc-label]').textContent=button.disabled?'CURRENTLY UNAVAILABLE':'ADD TO CART';
        };
        this.querySelectorAll('[data-bundle]').forEach(radio=>radio.addEventListener('change',()=>sync(radio)));
        sync(this.querySelector('[data-bundle]:checked'));
        form.addEventListener('submit',async(event)=>{
          event.preventDefault();
          if(button.disabled) return;
          button.disabled=true;
          const status=this.querySelector('[data-form-status]');
          status.textContent='Preparing your bracelet offer...';
          try {
            const properties={};
            const trip=form.querySelector('input[name="properties[Dream Trip Giveaway]"]');
            if(trip?.checked) properties['Dream Trip Giveaway']='Entered';
            await customElements.whenDefined('magora-cart');
            await document.querySelector('magora-cart').add({id:Number(form.querySelector('[data-variant-input]').value),quantity:Number(quantity.value),properties},button);
            status.textContent='';
          } catch(error) {
            status.textContent=error.message;
          } finally {
            button.disabled=false;
          }
        });
        const sticky=this.querySelector('[data-sticky]');
        if('IntersectionObserver' in window){
          this.observer=new IntersectionObserver(([entry])=>{
            const passed=entry.boundingClientRect.bottom<0;
            sticky.hidden=!passed;
          },{threshold:0});
          this.observer.observe(button);
        }
      }
      disconnectedCallback(){this.observer?.disconnect();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
